import { WorkspaceInvitationPolicy, WorkspaceTier } from "./local/Types";
import { User, UserSimplified, toUserSimplified } from "./User";
import { CompanyInfo, BillingInfo, SalesInfo, WorkspaceOverview } from "./WorkspaceAdmin";

// Role types for workspace members
export type WorkspaceMemberRole = 'owner' | 'admin' | 'member' | 'guest';

// Re-export for convenience
export { toUserSimplified };

export class Workspace {
  static COL = 'workspaces';
  created: Date = new Date();
  tier: WorkspaceTier = 'FREE';
  adminIds: string[] = [];
  description?: string;
  invitationKey?: string;
  invitationPolicy?: WorkspaceInvitationPolicy = 'ALLOW_ANY_EMAIL_DOMAIN';
  emailDomains: string[] = [];
  autoJoinEmailDomains: string[] = [];

  // Minimal owner info (for UI display) - use owner.id for owner ID
  owner: UserSimplified;

  // 슈퍼어드민 관리용 필드 (Phase 0)
  companyInfo?: CompanyInfo;           // 회사정보 (사용자 입력)
  billingInfo?: BillingInfo;           // 청구정보 (슈퍼어드민 관리)
  salesInfo?: SalesInfo;               // 영업정보 (슈퍼어드민 관리)
  overview?: WorkspaceOverview;        // Overview 캐시 (Cloud Functions 관리)

  constructor(public id: string, public name: string, owner: User | UserSimplified) {
    this.owner = toUserSimplified(owner);
    this.adminIds = [owner.id];
  }
}

// Workspace Member - with role support
export class WorkspaceMember {
  static COL = 'members'; //workspaces/members
  id: string;
  created: Date = new Date();

  // Role for access control
  role: WorkspaceMemberRole = 'member';

  // Custom quota override (optional)
  customQuotaBytes?: number;

  // Minimal user info (for UI display) - use user.id for user ID
  user: UserSimplified;

  // Workspace reference (for legacy queries)
  workspace?: Workspace;

  constructor(workspace: Workspace, user: User | UserSimplified, role: WorkspaceMemberRole = 'member') {
    this.workspace = workspace;
    this.user = toUserSimplified(user);
    this.id = user.id;
    this.role = role;
  }
}
